export const adsMinuteMedia = {
    testMode: false,
    floorPrice: 0,
    organizationId: '01h7z1ba59ed',
};
